import { format, isValid } from 'date-fns'
// import { produce } from "immer";

// type UpdateTypes = {
//   [key: string]: boolean | string | unknown | [];
// }

// export const update = async (
//   set: (fn: (state: UpdateTypes) => void) => void,
//   func: (state: UpdateTypes) => void
// ): Promise<void> => new Promise(resolve => {
//   set(produce((state: UpdateTypes) => {
//     func(state);
//     setTimeout(resolve);
//   }));
// });

let _cachedIsIos: boolean | undefined;

export const isIos = (): boolean => {
  if (typeof _cachedIsIos !== 'undefined') return _cachedIsIos;
  if (typeof window === 'undefined') return false;       // SSR guard

  const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  const detected = /iPad|iPhone|iPod/.test(ua);
  _cachedIsIos = detected;
  return detected;
};

export const formatDate = (dateString?: string, arrangement: string = 'MMMM d, yyyy') => {
  if (!dateString) return '';
  const d = new Date(dateString);
  return isValid(d) ? format(d, arrangement) : '';
};

export const handleCopyToClipboard = (
  fullPath: string,
  setCopied: React.Dispatch<React.SetStateAction<boolean>>
) => {
  return async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    try {
      await navigator.clipboard.writeText(fullPath);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
      return false;
    } catch (err) {
      console.error("copy failed", err);
    }
  };
};

export const handleDownloadPdf = async (docSelector: string | null, filename: string) => {
  const { default: html2pdf } = await import('html2pdf.js');
  if (!docSelector) return

  const doc = document.querySelector(docSelector) as HTMLDivElement | null;
  if (!doc) return;

  const clone = doc.cloneNode(true) as HTMLDivElement
  clone.querySelectorAll(".no-print").forEach(el => el.remove())

  clone.style.fontFamily = "Calibri, Helvetica, Arial, sans-serif"
  clone.style.fontSize = "12pt"
  clone.style.marginLeft = "0.5in";
  clone.style.width = "6in";
  clone.style.letterSpacing = "0.01em";

  clone.querySelectorAll("h1").forEach(h => {
    const el = h as HTMLDivElement
    el.style.fontSize = "18pt"
  });
  clone.querySelectorAll("p").forEach(p => {
    const el = p as HTMLDivElement
    el.style.fontFamily = "Times New Roman, Times, serif";
    el.style.marginBottom = "0.15in"
  });

  const worker = html2pdf();

  worker
    .set({
      margin: 10,
      filename: `${filename}.pdf`,
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    })
    .from(clone)
    .save()
};
